import React from 'react';
import { createRoot } from 'react-dom/client';
import axios from 'axios';
import { install401Redirect } from '@cloudgenie/ui';
import App from './App';
import '@cloudgenie/ui/styles.css';
import './index.css';

// Ported admin pages (Modules, Policies, Scheduler, Organization, …) call the
// backend on app.cloudgenie.co with bare axios/fetch and omit credentials.
// Send the .cloudgenie.co session cookie by default so cross-subdomain calls
// carry auth. install401Redirect also adds a global 401 → login redirect for
// expired sessions (E7). The id app owns /login, so loginBase is same-origin.
axios.defaults.withCredentials = true;
install401Redirect({ loginBase: '', axios });

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
